<template>
    <div class="">
        <el-page-header @back="toListPage">
            <p slot="content" class="font14px text-bold">批量编辑角色：增加权限</p>
        </el-page-header>
        <el-divider></el-divider>
        <div class="form-wrap">
            <el-form ref="form" :model="formItem" :rules="rules" label-width="120px">
                <el-form-item label="已选角色：">
                    <span>{{list.map(item=>item.role_name).join('、')}}</span>
                </el-form-item>

                <TitleLine num="1" title="数据权限设置"/>
                <div class="data-setting pl60" v-loading="dataLoading">
                    <h3 class="form-item-title">配置媒体</h3>
                    <el-form-item label="" label-width="20px">
                        <el-checkbox-group v-model="formItem.plat_ids">
                            <el-checkbox v-for="plat in platConfig" :label="plat.id" @change="changePlatId(plat.id,$event)" :key="plat.id" :disabled="plat.disabled" name="type">
                                {{plat.name}}
                            </el-checkbox>
                        </el-checkbox-group>
                    </el-form-item>

                    <h3 class="form-item-title" v-if="formItem.plat_ids.length>0">媒体账户权限配置  <span class="ml60 text-color-gray font12px text-normal">tips:双击可取消选择</span></h3>
                    <div v-for="platItem in platConfig" :key="'platCompany'+platItem.id">
                        <el-form-item v-if="formItem.plat_ids.includes(platItem.id)"
                                      :label="platItem.name" label-width="120px">
                            <el-radio-group v-model="formItem.plat_company[platItem.id]">
                                <el-radio v-for="item in platCompanyConfig[platItem.id]" :label="''+item.id" :disabled="item.disabled" :key="item.id" @dblclick.native="resetPlatCompany(platItem.id)">{{item.name}}
                                </el-radio>
                            </el-radio-group>


                        </el-form-item>
                    </div>


                    <h3 class="form-item-title" >数据日期权限配置</h3>
                    <el-form-item prop="data_days" label-width="120px">
                        <el-radio-group v-model="formItem.data_days_type" @change="changeDataDaysType">
                            <el-radio label="1" @dblclick.native="resetDataDaysType">整体配置</el-radio>
                            <el-radio label="2" @dblclick.native="resetDataDaysType">分模块配置</el-radio>
                        </el-radio-group>
                        <span class="ml60 text-color-gray font12px">tips:双击可取消选择</span>

                        <div v-if="formItem.data_days_type=='1'">
                            <el-radio-group v-model="formItem.data_days_global" @change="changeDataDaysGlobal">
                                <el-radio label="1">最近
                                    <el-input v-model="formItem.data_days" size="mini" :disabled="formItem.data_days_global=='2'" style="width: 60px;"></el-input>
                                    天</el-radio>
                                <el-radio label="2">不限</el-radio>
                            </el-radio-group>
                        </div>
                        <div v-else>
                            <span class="font12px text-color">请在【页面与操作权限配置】各模块处配置</span>
                        </div>
                    </el-form-item>

                    <h3 class="form-item-title" v-if="formItem.plat_ids.length>0">数据维度权限配置</h3>
                    <div v-for="platItem in platConfig" :key="'dimensionType'+platItem.id">
                        <el-form-item v-if="formItem.plat_ids.includes(platItem.id)"
                                      :prop="'dimension_type.'+platItem.id"
                                      :label="platItem.name" label-width="120px">
                            <template v-if="dimensionTypeConfig[platItem.id].length>0">
                                <el-checkbox-group v-model="formItem.dimension_type[platItem.id]">
                                    <el-checkbox v-for="item in dimensionTypeConfig[platItem.id]" :label="item.id" @change="changeDimensionTypeItem(platItem.id,item,$event)" :disabled="item.default_checked" :key="'dimension-type'+item.id"
                                                 name="dimension-type">
                                        {{item.display_type_name}}
                                    </el-checkbox>
                                </el-checkbox-group>
                            </template>
                            <span v-else class="text-color-gray pl20">暂无数据</span>
                        </el-form-item>
                    </div>

                    <h3 class="form-item-title" v-if="formItem.plat_ids.length>0">数据类型权限配置</h3>
                    <div v-for="platItem in platConfig" :key="'dataType'+platItem.id">
                        <el-form-item v-if="formItem.plat_ids.includes(platItem.id)"
                                      :prop="'data_type.'+platItem.id"
                                      :label="platItem.name" label-width="120px">
                            <template v-if="dataTypeConfig[platItem.id].length>0">
                                <el-checkbox-group v-model="formItem.data_type[platItem.id]">
                                    <el-checkbox v-for="item in dataTypeConfig[platItem.id]" @change="changeDateTypeItem(item,$event)" :label="item.id" :key="'data-type'+item.id"
                                                 name="data-type">
                                        {{item.display_type_name}}
                                    </el-checkbox>
                                </el-checkbox-group>
                            </template>
                            <span v-else class="text-color-gray pl20">暂无数据</span>
                        </el-form-item>
                    </div>
                </div>
                <TitleLine num="2" title="页面与操作权限配置"/>
                <div class="function-tips ml48 mb20">
                    <p>选中上级模块复选框并不会自动选中下级模块与页面，若需选中下级所有模块与页面，则需要点击【全选】</p>
                    <p>复选框表示选中哪些模块/页面或功能，提供查看与操作权限。全选表示选中下级所有模块/页面/操作功能复选框。</p>
                </div>
                <div class="pr20 add-role-page" v-loading="dataLoading">
                    <el-collapse v-model="activeNames" class="ml30 my-collapse-1">
                        <el-collapse-item v-for="module1 in operationConfig" :name="module1.id">
                            <template slot="title">
                                <CollapseTitle :is-active="activeNames.includes(module1.id)"
                                               :module="module1"
                                               :data-days="formItem.data_days_type"
                                               @title-check-all="handleTitleCheckAll"
                                               @change-module="handleChangeModule"
                                />
                            </template>
                            <el-collapse v-if="module1.type=='0'&&((module1.children||[]).some(item=>item.type=='0'))"
                                         v-model="activeNames" class="my-collapse-2">
                                <el-collapse-item v-for="module2 in module1.children" :name="module2.id">
                                    <template slot="title">
                                        <CollapseTitle
                                            :is-active="activeNames.includes(module2.id)"
                                            :data-days="formItem.data_days_type"
                                            :module="module2"
                                            @title-check-all="handleTitleCheckAll"
                                            @change-module="handleChangeModule"
                                        />
                                    </template>
                                    <el-collapse
                                        v-if="module2.type=='0'&&((module2.children||[]).some(item=>item.type=='0'))"
                                        v-model="activeNames" class="my-collapse-3">
                                        <el-collapse-item v-for="module3 in module2.children" :name="module3.id">
                                            <template slot="title">
                                                <CollapseTitle
                                                    :is-active="activeNames.includes(module3.id)"
                                                    :data-days="formItem.data_days_type"
                                                    :module="module3"
                                                    @title-check-all="handleTitleCheckAll"
                                                    @change-module="handleChangeModule"
                                                />
                                            </template>
                                            <el-collapse
                                                v-if="module3.type=='0'&&((module3.children||[]).some(item=>item.type=='0'))"
                                                v-model="activeNames" class="my-collapse-4">
                                                <el-collapse-item v-for="module4 in module3.children"
                                                                  :name="module4.id">
                                                    <template slot="title">
                                                        <CollapseTitle
                                                            :is-active="activeNames.includes(module4.id)"
                                                            :module="module4"
                                                            :data-days="formItem.data_days_type"
                                                            @title-check-all="handleTitleCheckAll"
                                                            @change-module="handleChangeModule"
                                                        />
                                                    </template>
                                                    <CollapseContent
                                                        page="batch"
                                                        :module="module4"
                                                        :form-plats="formItem.plat_ids"
                                                        :allow-actions="allowActions"
                                                        :tag-editable="tagActionIdsEditable"
                                                        :special-config="formItem.special_config"
                                                        class="collapse-con-4"
                                                        @check-page="handleTitleCheckAll"
                                                        @change-page="handleChangeModule"
                                                        @save-fields="handleSaveFields"
                                                        @save-tag-fields="handleSaveTagFields"
                                                        @save-roles="handleSaveOptionalRoles"
                                                        @save-role-action="handleSaveRoleAction"
                                                        @save-period="handleSavePeriodAction"
                                                        @save-func="handleSaveFunc" />
                                                </el-collapse-item>
                                            </el-collapse>
                                            <CollapseContent
                                                page="batch"
                                                :module="module3"
                                                :form-plats="formItem.plat_ids"
                                                :allow-actions="allowActions"
                                                :tag-editable="tagActionIdsEditable"
                                                :special-config="formItem.special_config"
                                                class="collapse-con-3"
                                                @check-page="handleTitleCheckAll"
                                                @change-page="handleChangeModule"
                                                @save-fields="handleSaveFields"
                                                @save-tag-fields="handleSaveTagFields"
                                                @save-roles="handleSaveOptionalRoles"
                                                @save-role-action="handleSaveRoleAction"
                                                @save-period="handleSavePeriodAction"
                                                @save-func="handleSaveFunc" v-else/>
                                        </el-collapse-item>
                                    </el-collapse>
                                    <CollapseContent
                                        page="batch"
                                        :module="module2"
                                        :form-plats="formItem.plat_ids"
                                        :allow-actions="allowActions"
                                        :tag-editable="tagActionIdsEditable"
                                        :special-config="formItem.special_config"
                                        class="collapse-con-2"
                                        @check-page="handleTitleCheckAll"
                                        @change-page="handleChangeModule"
                                        @save-fields="handleSaveFields"
                                        @save-tag-fields="handleSaveTagFields"
                                        @save-roles="handleSaveOptionalRoles"
                                        @save-role-action="handleSaveRoleAction"
                                        @save-period="handleSavePeriodAction"
                                        @save-func="handleSaveFunc" v-else/>
                                </el-collapse-item>
                            </el-collapse>
                            <CollapseContent
                                page="batch"
                                :module="module1"
                                :form-plats="formItem.plat_ids"
                                :allow-actions="allowActions"
                                :tag-editable="tagActionIdsEditable"
                                :special-config="formItem.special_config"
                                class="collapse-con-1"
                                @check-page="handleTitleCheckAll"
                                @change-page="handleChangeModule"
                                @save-fields="handleSaveFields"
                                @save-tag-fields="handleSaveTagFields"
                                @save-roles="handleSaveOptionalRoles"
                                @save-role-action="handleSaveRoleAction"
                                @save-period="handleSavePeriodAction"
                                @save-func="handleSaveFunc" v-else/>
                        </el-collapse-item>
                    </el-collapse>
                </div>




                <el-form-item label="" label-width="0">
                    <div class="form-footer tac mt20">
                        <el-button type="default" class="action-btn mr20" @click="toListPage">取消</el-button>
                        <el-button type="primary" class="submit-btn action-btn ml20" :loading="submitLoading"
                                   @click="handleSubmit">保存
                        </el-button>
                    </div>
                </el-form-item>
            </el-form>


        </div>

    </div>
</template>

<script>
    import utils from '@/libs/utils.js';
    import {platMap} from '@/constant/index.js';
    import TitleLine from '@/components/title-line.vue';
    import CollapseTitle from '../components/collapseTitle';
    import CollapseContent from '../components/collapseContent';
    import API from '@/api/role.js';
    export default {
        name: "BatchAdd",
        components: {
            TitleLine,
            CollapseTitle,
            CollapseContent,
        },
        props:{
            list:Array,
        },
        data(){
            let _this = this;
            let validateEmoji = (rule, value, callback)=>{
                let reg = /(\ud83c[\udc00-\udfff])|(\ud83d[\udc00-\udfff])|(\ud83e[\udc00-\udfff])|[\u2100-\u32ff]|[\u0030-\u007f][\u20d0-\u20ff]|[\u0080-\u00ff]/g;
                if(reg.test(value)){
                    callback(new Error('不可输入表情'));
                }else{
                    callback();
                }
            };
            let validateDataDays = (rule, value, callback)=>{
                console.log('validateDataDays',value)
                if(!_this.formItem.data_days_type){
                    callback();
                }else if(_this.formItem.data_days_type=='2'){
                    callback();
                }else{
                    if(_this.formItem.data_days_global=='2'){
                        callback();
                    }else{
                        if(!value){
                            callback(new Error('天数不可为空'));
                        }else if(isNaN(value)){
                            callback(new Error('天数格式不正确'));
                        }else if(value<=0){
                            callback(new Error('天数需大于0'));
                        }else if(value>1000){
                            callback(new Error('最大不大于1000'));
                        }else if(parseInt(value)!=value){
                            callback(new Error('请填写整数'));
                        }else{
                            callback();
                        }
                    }
                }
            };
            return {
                dataLoading:false,
                submitLoading:false,
                formItem:{
                    plat_ids: [],
                    plat_company: {},
                    data_type: {},
                    dimension_type: {},
                    action_ids: [],
                    role_action: {},
                    sub_data_days:{},
                    special_config:{
                        optional_role:'',
                        tag_action_ids_editable:'',
                        /* 自动化报告-统计周期 */
                        statistical_period:{
                            customize_the_latest_days:'',
                            customize_the_start_date:'',
                        },
                    },
                    data_days_type:'',      //1-整体配置，2-分模块配置
                    data_days:null,
                    data_days_global:'',
                },
                rules:{
                    data_days:[
                        { validator: validateDataDays, trigger: 'blur' },
                    ],
                    // "data_type.1": [
                    //     {type: 'array', required: true, message: '至少需要配置一个数据类型', trigger: 'change'}
                    // ],
                    // "dimension_type.1": [
                    //     {type: 'array', required: true, message: '至少需要配置一个数据维度', trigger: 'change'}
                    // ],
                    // "data_type.3": [
                    //     {type: 'array', required: true, message: '至少需要配置一个数据类型', trigger: 'change'}
                    // ],
                    // "dimension_type.3": [
                    //     {type: 'array', required: true, message: '至少需要配置一个数据维度', trigger: 'change'}
                    // ],
                    // "data_type.4": [
                    //     {type: 'array', required: true, message: '至少需要配置一个数据类型', trigger: 'change'}
                    // ],
                    // "dimension_type.4": [
                    //     {type: 'array', required: true, message: '至少需要配置一个数据维度', trigger: 'change'}
                    // ],
                    // "data_type.7": [
                    //     {type: 'array', required: true, message: '至少需要配置一个数据类型', trigger: 'change'}
                    // ],
                    // "dimension_type.7": [
                    //     {type: 'array', required: true, message: '至少需要配置一个数据维度', trigger: 'change'}
                    // ],
                    // "data_type.8": [
                    //     {type: 'array', required: true, message: '至少需要配置一个数据类型', trigger: 'change'}
                    // ],
                    // "dimension_type.8": [
                    //     {type: 'array', required: true, message: '至少需要配置一个数据维度', trigger: 'change'}
                    // ],
                },
                dataTypeConfig: {},      // 2-广告投放数据 3-财务数据
                dimensionTypeConfig: {},      // 维度权限配置
                platCompanyConfig: {},   // 1-全部账户 2-按照客户管理绑定
                platConfig: [],      // 1-OPPO 3-vivo 4-华为 7-mi 8-爱奇艺 9-Apple
                operationConfig: [],     // 页面与操作权限配置
                activeNames: [],
                tagActionIdsEditable:{},     // 单独存放tag标签页面的字段可编辑的值

            }
        },
        computed: {
            allowActions(){
                return {
                    plat_ids:this.formItem.plat_ids,
                    dimension_type:this.formItem.dimension_type,
                    data_type:this.formItem.data_type,
                }
            },
        },
        created(){
            let routeQuery = this.$route.query || {};
            console.log('batchRemove created',routeQuery);
            let roleList = this.list||[];
            if(roleList.length<=0){
                this.toListPage();
            }else{
                this.getConfig();
            }
        },
        methods:{
            toListPage(){
                this.$emit('togglePage','listPage');
                let routeParams = this.$route.params || {};
                let original = routeParams.original;
                this.$router.replace({
                    name: 'role_management',
                    query: {
                        action: 'list',
                        t: +new Date(),
                    },
                    params:{
                        original:original,
                    }
                });
            },
            handleSubmit(){
                console.log('handleSubmit',this.formItem);
                this.$refs['form'].validate((valid)=>{
                    if(valid){

                        if(this.list.length<=0) return this.$message.error('请选择需要批量编辑的角色');

                        let platsChecked = this.formItem.plat_ids;
                        let platCompanyChecked = {};
                        let dataTypeChecked = {};
                        let dimensionTypeChecked= {};

                        platsChecked.forEach(item=>{
                            platCompanyChecked[item] = this.formItem.plat_company[item];
                            let dataTypeVal = this.formItem.data_type[item].join(',');
                            if(dataTypeVal.length>0){
                                dataTypeChecked[item] = dataTypeVal;
                            }
                            dimensionTypeChecked[item] = this.formItem.dimension_type[item].join(',');
                        });

                        let data = {
                            type:'1',       // 0-去除权限，1-增加权限
                            plat_ids: this.formItem.plat_ids.join(','),
                            data_days_type:this.formItem.data_days_type,
                            plat_company: JSON.stringify(platCompanyChecked),
                            data_type: JSON.stringify(dataTypeChecked),
                            dimension_type: JSON.stringify(dimensionTypeChecked),
                            role_ids:this.list.map(item=>item.role_id).join(','),
                        };

                        if(this.formItem.data_days_type=='1'){
                            data.data_days = this.formItem.data_days||'-1';
                        }else{
                            //json,各模块对应的日期权限
                            let subDataDays = this._getSubDataDaysVal(this.operationConfig,{});
                            if(Object.values(subDataDays).some(item=>item<=0&&item!=-1)){
                                return this.$message.error('分模块数据日期权限配置：天数需大于0');
                            }
                            data.sub_data_days =  JSON.stringify(subDataDays);
                        }

                        // 权限id '13,14,15,32,16,17,18'
                        let actionIds = this._getCheckedVal(this.operationConfig,[]);
                        // if(actionIds.length<=0){
                        //     return this.$message.error('请选择模块、页面、操作权限');
                        // }

                        /* 找到page页面，然后找edit权限是否开启，只有开启的才提交tag_action_ids_editable数据 */
                        let tagActionIdsEditable = {};
                        let tagPageId = Object.keys(this.tagActionIdsEditable);
                        tagPageId.forEach(item=>{
                            let pageItem = this._findModuleById(this.operationConfig,item)||{};
                            let pageFun = pageItem.func||[];
                            let editFun = pageFun.find(inner=>inner.name=="edit")||{};
                            if(actionIds.includes(editFun.id)){
                                tagActionIdsEditable[item] = this.tagActionIdsEditable[item];
                            }
                        });
                        this.formItem.special_config.tag_action_ids_editable = tagActionIdsEditable;
                        data.special_config = JSON.stringify(this.formItem.special_config);

                        //json,各模块对应的数据权限
                        let roleAction = this._getRoleActionVal(this.operationConfig,{});
                        // 保存有效的值
                        let roleActionVal = {};
                        for (let item in roleAction){
                            if(roleAction[item]){
                                roleActionVal[item] = roleAction[item];
                            }
                        }


                        data.action_ids = utils.unique(actionIds).join(',');
                        data.role_action = JSON.stringify(roleActionVal);


                        // return console.log('role submit',data);
                        this.submitLoading = true;

                        API.batchEditRole(data).then(res => {
                            this.$message.success(res.info || '操作成功');
                            this.submitLoading = false;
                            this.toListPage();
                        }, (err) => {
                            console.log('addRole error', err);
                            let errData = err.data||[];
                            if(err.code==0&&errData.length>0){
                                this.$notify.error({
                                    title: err.info||'请求失败',
                                    message: errData.join('；'),
                                    duration: 0
                                });
                            }else{
                                this.$message.error(err.info||'操作失败');
                            }
                            this.submitLoading = false;
                        });
                    }else{
                        this.$message.error('表单数据填写有误，请检查后重新提交');
                    }
                })
            },
            getConfig(){
                this.dataLoading = true;
                return API.getAddRoleConfig().then(res => {
                    let resData = res.data || {};
                    let permConfig = resData.data_config.perm_config||[];
                    permConfig.forEach(item=>{
                        this.platCompanyConfig[item.plat_id] = (item.plat_company_config||[]).sort((a,b)=>b.id-a.id);
                        this.dataTypeConfig[item.plat_id] = item.data_type_config||[];
                        this.dimensionTypeConfig[item.plat_id] = item.dimension_type_config||[];
                    });
                    this.platConfig = resData.data_config.plat_config || [];
                    this.operationConfig = resData.operation_config || [];
                    this.activeNames = this.operationConfig.map(item=>item.id);

                    this.$store.commit('roleData/SET_ROLE_LIST', resData.role_list || []);

                    /*先设置默认值*/
                    this.platConfig.forEach(item => {
                        this.$set(this.formItem.data_type, item.id, []);    //默认选中广告投放数据
                        this.$set(this.formItem.dimension_type, item.id, []);    //
                    });

                    this.$nextTick(()=>{
                        // this.initConfigData();
                    });

                    this.dataLoading = false;
                }, (err) => {
                    console.log('getConfig error', err);
                    this.dataTypeConfig = {};
                    this.dimensionTypeConfig = {};
                    this.platCompanyConfig = {};
                    this.platConfig = [];
                    this.operationConfig = [];
                    this.dataLoading = false;
                });
            },
            changePlatId(id,val){
                console.log('changePlatId',id,val);
                if(!val){
                    let mDataCenterAnalysis = this._findModuleByName(this.operationConfig,'data_query_analysis');
                    if(mDataCenterAnalysis){
                        let mPlatAnalysis = (mDataCenterAnalysis.children||[]).find(inner=>inner.name==('data_'+id));
                        if(mPlatAnalysis){
                            this.handleChangeModule(false, mPlatAnalysis);
                        }
                    }
                    let mAppKpiManage = this._findModuleByName(this.operationConfig,'app_kpi_manage');
                    if(mAppKpiManage){
                        let mPlatKpi = (mAppKpiManage.children||[]).find(inner=>inner.name==('app_kpi_'+id));
                        if(mPlatKpi){
                            this.handleChangeModule(false, mPlatKpi);
                        }
                    }

                    /* 处理自动化报告-日报 */
                    let mDailyTaskPage = this._findModuleByName(this.operationConfig,'daily_task_page');
                    if(mDailyTaskPage){
                        let fields = mDailyTaskPage.fields||[];
                        let mPlatData = fields.find(inner=>inner.name==('data_'+id));
                        if(mPlatData){
                            this.handleChangeModule(false, mPlatData);
                        }
                    }
                }else{
                    /* 选中某渠道时，把维度权限配置中的其他选中 */
                    let platDimensionConfig = this.dimensionTypeConfig[id]||[];
                    let defaultChecked = platDimensionConfig.filter(item=>item.default_checked);
                    let formDimension = this.formItem.dimension_type[id]||[];
                    defaultChecked.forEach(item=>{
                        if(!formDimension.includes(item.id)){
                            formDimension.push(item.id);
                        }
                    })
                }
            },
            changeDimensionTypeItem(platId,item,val){
                console.log('changeDimensionTypeItem',platId,item,val);
                let actionItem = item;
                if(item.default_checked&&!val){
                    let formDimension = this.formItem.dimension_type[platId]||[];
                    if(!formDimension.includes(item.id)){
                        formDimension.push(item.id);
                    }

                    return this.$message.error('该字段为必选项');
                }
                /* 处理综合查询分析 */
                let mDataCenterAnalysis = this._findModuleByName(this.operationConfig,'data_query_analysis');
                if(mDataCenterAnalysis) {
                    let mPlatAnalysis = (mDataCenterAnalysis.children||[]).find(inner=>inner.name==('data_'+item.plat_id));
                    if(mPlatAnalysis) {
                        let platDimension = mPlatAnalysis.dimension||[];
                        let actionItem = platDimension.find(inner=>inner.mid==item.id);
                        this._setFieldsChildrenVal(actionItem,val);
                    }
                }

                /* 处理自动化报告 */
                let dailyTaskPage = this._findModuleByName(this.operationConfig,'daily_task_page');
                if(dailyTaskPage){
                    console.log('dailyTaskPage',dailyTaskPage);
                    let dimension = dailyTaskPage.dimension||[];
                    let platDimension = dimension.find(item=>item.name=='data_'+platId);
                    if(platDimension){
                        let children = platDimension.children||[];
                        let actionGroup = children.find(inner=>inner.mid==actionItem.id);
                        if(actionGroup){
                            this._setFieldsChildrenVal(actionGroup,val);
                        }
                    }
                }


            },
            changeDateTypeItem(item,val){
                console.log('changeDateTypeItem',item,val);
                let mDataCenterAnalysis = this._findModuleByName(this.operationConfig,'data_query_analysis');
                if(!mDataCenterAnalysis) return;

                let mPlatAnalysis = (mDataCenterAnalysis.children||[]).find(inner=>inner.name==('data_'+item.plat_id));
                if(!mPlatAnalysis) return;

                let platFields = mPlatAnalysis.fields||[];

                let actionItem = platFields.find(inner=>inner.mid==item.id);
                this._setFieldsChildrenVal(actionItem,val);
            },
            resetDataDaysType(){
                this.formItem.data_days_type = '';
                this.formItem.data_days = null;
                this.formItem.data_days_global = '';
            },
            resetPlatCompany(platId){
                console.log('resetPlatCompany',platId);
                this.$set(this.formItem.plat_company,platId+'','');
            },
            changeDataDaysType(val){
                console.log('changeDataDaysType',val);
                if(val=='2'){
                    let mDataCenterAnalysis = this._findModuleByName(this.operationConfig,'data_query_analysis');
                    if(!mDataCenterAnalysis) return;
                    this.$set(mDataCenterAnalysis,'data_days_global','1');
                    this.$set(mDataCenterAnalysis,'data_days',null);
                }else if(val=='1'){
                    this.formItem.data_days_global = '1';
                    this.formItem.data_days = null;
                }
                // this.$refs.form.validateField('data_days');
                this.$refs.form.clearValidate('data_days');
            },
            changeDataDaysGlobal(val){
                console.log('changeDataDaysGlobal',val);
                this.formItem.data_days = null;
                // this.$refs.form.validateField('data_days');
                this.$refs.form.clearValidate('data_days');
            },




            handleTitleCheckAll(module) {
                console.log('title-check-all',module);
                this._setChildrenVal(module,true);
                this._setParentVal(module,true);
            },
            handleChangeModule(val, module) {
                console.log('handleChangeModule change-module',val,module);
                if(val){
                    /* 循环遍历上级节点-选中 */
                    this._setParentVal(module,val);
                    /* 涉及到渠道权限的，还需要验证有没有勾选该渠道 */
                    if(module.name=='data_query_analysis'||module.name=='app_kpi_manage'){
                        let childModule = module.children||[];
                        childModule.forEach(item=>{
                            if(item.name=='data_all'){
                                this._setChildrenVal(item,val);
                            }else{
                                let moduleNameData = (item.name||'').split('_');
                                let platData = moduleNameData.length>1?moduleNameData[1]:'';
                                let platId = platData.match(/\d+(\.\d+)?/g)||[];
                                if(platId.length>0&&this.formItem.plat_ids.includes(platId[0])){
                                    this._setChildrenVal(item,val);
                                }
                            }
                        })
                    }else {
                        this._setChildrenVal(module,val);
                    }
                    if(module.type=='1'){
                        //勾选的是页面
                        module.func.forEach(item=>{
                            this._setFieldsChildrenVal(item,false);
                        });
                    }
                }else{
                    /* 循环遍历下级节点-取消选中 */
                    this._setChildrenVal(module,val);
                    // this._setChildrenVal(module,val);
                    if(module.type=='1'){
                        //勾选的是页面
                        let fields = module.fields||[];
                        fields.forEach(item=>{
                            this._setFieldsChildrenVal(item,false);
                        });

                        let dimension = module.dimension||[];
                        dimension.forEach(item=>{
                            this._setFieldsChildrenVal(item,false);
                        });
                        let func = module.func||[];
                        func.forEach(item=>{
                            this._setFieldsChildrenVal(item,false);
                        });
                        this.$set(module,'checkedFunc',[]);
                    }
                }


            },
            handleSaveFields(val, page,type) {
                // console.log('save-fields',val,page);
                let targetPage = this._findModuleById(this.operationConfig, page.id);
                let fields = type=='fields'?targetPage.fields:targetPage.dimension;
                let selectedVal = val;

                fields.forEach(item=>{
                    this.$set(item,'checked',selectedVal.includes(item.id));
                    if(item.children&&item.children.length>0){
                        let itemChild = item.children;
                        itemChild.forEach(item2=>{
                            this.$set(item2,'checked',selectedVal.includes(item2.id));
                            if(item2.children&&item2.children.length>0){
                                let item2Child = item2.children;
                                item2Child.forEach(item3=>{
                                    this.$set(item3,'checked',selectedVal.includes(item3.id));
                                    if(item3.children&&item3.children.length>0){
                                        let item3Child = item3.children;
                                        item3Child.forEach(item4=>{
                                            this.$set(item4,'checked',selectedVal.includes(item4.id));
                                        })
                                    }
                                })
                            }
                        })
                    }
                });
            },
            handleSaveTagFields(page,viewChecked,editChecked){
                this.handleSaveFields(viewChecked.map(item=>item.id), page,'fields');
                if(editChecked.length>0){
                    this.tagActionIdsEditable[page.id] = editChecked.join(',');
                }else if(this.tagActionIdsEditable[page.id]){
                    delete this.tagActionIdsEditable[page.id];
                }
            },
            handleSaveOptionalRoles(val,module){
                // console.log('handleSaveOptionalRoles',val,module);
                this.$set(module,'optional_role_val',val.optional_role);
                this.formItem.special_config.optional_role = val.optional_role.join(',');
            },
            handleSaveFunc(val, module) {
                let targetPage = this._findModuleById(this.operationConfig, module.id);
                let func = targetPage.func;
                let checkedFunc = val;
                func.forEach(data=>{
                    data.checked = checkedFunc.includes(data.id);
                });

                if(val.length>0){
                    this._setParentVal(module,true);

                    /* 如果保存了功能权限，那么维度权限的必选项也需要选中 */
                    let dimension = module.dimension||[];
                    dimension.forEach(group=>{
                        let children = group.children||[];
                        if(children.some(item=>item.default_check=='1')){
                            this.$set(group,'checked',true);
                        }
                        children.forEach(item=>{
                            if(item.default_check){
                                this.$set(item,'checked',true);
                            }
                        })
                    });
                }
            },
            handleSaveRoleAction(val, module){
                let targetPage = this._findModuleById(this.operationConfig, module.id);
                targetPage.role_action = val;
            },
            handleSavePeriodAction(module,data){
                console.log('handleSavePeriodAction',module,data);
                let targetPage = this._findModuleById(this.operationConfig, module.id);
                let selectedVal = data.period||[];
                let fields = targetPage.statistical_period||[];
                fields.forEach(item=>{
                    this.$set(item,'checked',selectedVal.includes(item.id));
                });

                let periodConfig = this.formItem.special_config.statistical_period||{};
                this.$set(periodConfig,'customize_the_latest_days',data.data_days||'');
                this.$set(periodConfig,'customize_the_start_date',data.start_date||'');
            },
            _findModuleByName(data, name) {
                for (let item in data) {
                    if (data[item].name == name) {
                        return data[item];
                    } else {
                        let child = data[item].children;
                        if (child && child.length > 0) {
                            let result = this._findModuleByName(child, name);
                            if (result) {
                                return result;
                            }
                        }
                    }
                }
            },
            _getRoleActionVal(list,result){
                list.forEach(item=>{
                    /*  原来的判断：item.type=='1'&&item.checked，批量增加权限时不必选中页面*/
                    if(item.type=='1'){
                        result[item.id] = item.role_action;
                    }else if(item.children&&item.children.length>0){
                        return this._getRoleActionVal(item.children,result);
                    }
                });
                return result;
            },
            _findModuleById(data, id) {
                for (let item in data) {
                    if (data[item].id == id) {
                        return data[item];
                    } else {
                        let child = data[item].children;
                        if (child && child.length > 0) {
                            let result = this._findModuleById(child, id);
                            if (result) {
                                return result;
                            }
                        }
                    }
                }
            },
            _getCheckedVal(list,result){
                list.forEach(item=>{
                    // console.log('list.forEach',item.display_name,item.id,item.checked,result);
                    if(item.checked){
                        result.push(item.id);
                    }
                    if(item.children&&item.children.length>0){
                        if(item.children.some(item=>item.checked)){
                            result.push(item.id);
                        }
                        return this._getCheckedVal(item.children,result);
                    }
                    if(item.type=='1'){
                        let func = this._getCheckedVal(item.func,result);
                        let fields = [];
                        let dimension = [];
                        let period = [];

                        /*判断是不是综合查询分析的子页面*/
                        let isPlatDataQueryAnalysisPage = item.pid=='73';
                        let modulePlatId = null;
                        let platDimensionType = [];
                        let platDataType = [];

                        if(isPlatDataQueryAnalysisPage){
                            let moduleNameData = (item.name||'').split('_');
                            let platData = moduleNameData.length>1?moduleNameData[1]:'';
                            let platId = platData.match(/\d+(\.\d+)?/g)||[];
                            modulePlatId = platId[0]||'';
                            // console.log('modulePlatId',modulePlatId);
                        }
                        if(modulePlatId){
                            platDataType = this.formItem.data_type[modulePlatId];
                            platDimensionType = this.formItem.dimension_type[modulePlatId];

                            let checkedFields = item.fields.filter(field=>platDataType.includes(field.mid));
                            let checkedDimensions = item.dimension.filter(field=>platDimensionType.includes(field.mid));
                            fields = this._getCheckedVal(checkedFields,result);
                            dimension = this._getCheckedVal(checkedDimensions,result);

                        }else{

                            fields = this._getCheckedVal(item.fields,result);
                            dimension = this._getCheckedVal(item.dimension,result);
                            period = this._getCheckedVal(item.statistical_period||[],result);
                        }

                        result.concat(func,fields,dimension,period);
                    }
                });
                return result;
            },
            _getSubDataDaysVal(list,result){
                list.forEach(item=>{
                    if(item.name=='data_query_analysis'&&item.checked){
                        if(item.data_days_global=='2'){
                            result[item.id] = '-1';
                        }else{
                            result[item.id] = item.data_days;
                        }

                    }else if(item.children&&item.children.length>0){
                        return this._getSubDataDaysVal(item.children,result);
                    }
                });
                return result;
            },
            _setParentVal(module,val){
                if(module.type=='1'){
                    // page页面
                    let fields = module.fields||[];
                    let checkedFields = this._getCheckedVal(fields,[]);
                    // 如果已选字段为空，表示初次添加，默认设置为所有字段全选
                    if(checkedFields.length<=0){
                        fields.forEach(field=>{
                            this._setChildrenVal(field,true);
                        })
                    }
                }
                this.$set(module,'checked',val);
                let pid = module.pid;
                let pModule = this._findModuleById(this.operationConfig,pid);
                if(pModule){
                    this._setParentVal(pModule,val);
                }
            },
            _setChildrenVal(module,val){
                if(!module.disabled){
                    this.$set(module,'checked',val);
                }
                if(module.children&&module.children.length>0){
                    let children = module.children;
                    children.forEach(child=>{
                        this._setChildrenVal(child,val);
                    })
                }
                if(module.type=='1'){

                    /*判断是不是综合查询分析的子页面*/
                    let isPlatDataQueryAnalysisPage = module.pid=='73';
                    let modulePlatId = null;
                    let platDimensionType = [];
                    let platDataType = [];
                    let checkedPlat = this.formItem.plat_ids;
                    if(isPlatDataQueryAnalysisPage){
                        let moduleNameData = (module.name||'').split('_');
                        let platData = moduleNameData.length>1?moduleNameData[1]:'';
                        let platId = platData.match(/\d+(\.\d+)?/g)||[];
                        modulePlatId = platId[0]||'';
                        // console.log('modulePlatId',modulePlatId);
                    }
                    if(modulePlatId){
                        platDataType = this.formItem.data_type[modulePlatId];
                        platDimensionType = this.formItem.dimension_type[modulePlatId];

                        let isCheckedPlat = checkedPlat.includes(modulePlatId);
                        if(isCheckedPlat){
                            if(module.fields&&module.fields.length>0){
                                let fields = module.fields;
                                fields.forEach(item=>{
                                    if(platDataType.includes(item.mid)){
                                        this._setFieldsChildrenVal(item,true);
                                    }else{
                                        this._setFieldsChildrenVal(item,false);
                                    }
                                })
                            }
                            if(module.dimension&&module.dimension.length>0&&checkedPlat.includes(modulePlatId)){
                                let dimension = module.dimension;
                                dimension.forEach(item=>{
                                    if(platDimensionType.includes(item.mid)){
                                        this._setFieldsChildrenVal(item,true);
                                    }else{
                                        this._setFieldsChildrenVal(item,false);
                                    }
                                })
                            }
                        }else{
                            this._setFieldsChildrenVal(module,false);
                        }





                    }else{
                        if(module.fields&&module.fields.length>0){
                            let fields = module.fields;
                            fields.forEach(item=>{
                                this._setChildrenVal(item,val);
                            })
                        }
                        if(module.dimension&&module.dimension.length>0){
                            let dimension = module.dimension;
                            dimension.forEach(item=>{
                                this._setChildrenVal(item,val);
                            })
                        }
                    }

                    if(module.func&&module.func.length>0){
                        let func = module.func;
                        func.forEach(item=>{
                            this._setChildrenVal(item,val);
                        })
                    }

                    if(module.statistical_period&&module.statistical_period.length>0){
                        if(val){
                            /*选中 第一项*/
                            this._setChildrenVal(module.statistical_period[0],val);
                        }else{
                            /*取消选中*/
                            let period = module.statistical_period;
                            period.forEach(item=>{
                                this._setChildrenVal(item,val);
                            })
                        }
                    }
                }
            },
            _setFieldsChildrenVal(field,val){
                if(!field.disabled){
                    this.$set(field,'checked',val);
                }
                let children = field.children||[];
                children.forEach(item=>{
                    this._setFieldsChildrenVal(item,val);
                })
            },
        },
        mounted() {
            console.log(1, 'batch add.mounted');
        },
        destroyed() {
            console.log(1, 'batch add.destroyed');
        }
    }
</script>

<style lang="scss" scoped>
    .form-item-title {
        color: #17233d;
        margin-bottom: 8px;
        font-weight: normal;
    }

    .text-color{
        color: #606266;
    }

    .form-footer .action-btn {
        width: 120px;
    }
    .add-role-page,.data-setting{
        min-height: 200px;
    }

    .function-tips{
        color: #515a6e;
    }

    ::v-deep .el-collapse-item .el-collapse-item__header{
        background-color: #f2f2f2!important;
        border-bottom: 1px solid #aaa;
        height: 40px;
        line-height: 40px;
        padding-left: 14px;
    }

    ::v-deep .my-collapse-2 .el-collapse-item .el-collapse-item__header{
        padding-left: 30px;
    }

    .collapse-con-2{
        margin: 6px 50px;
    }
</style>
